import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'

export const getBaseTagClasses = (...additionalClasses) =>
  classnames('details-area__tag', 'details-area__format-tag', ...additionalClasses)
